import requestConfig from 'app/requests/Prebooking.requests'
import CommentsLog from 'app/shared-components/CommentsLog'

import useGetPreBookingComments from './hooks/useGetPreBookingComments'
import useRemovePreBookingComment from './hooks/useRemovePreBookingComment'
import useStyles from './preBookingComment.style'

const PreBookingComment = ({
    id,
}: {
    id: number,
}) => {
    const {
        classes,
    } = useStyles()
    const {
        onParamsChange,
        loadData,
        refetch,
    } = useGetPreBookingComments(id)

    const deleteComment = useRemovePreBookingComment({
        onSuccess: refetch,
    })

    return (
        <CommentsLog
            requestConfigCreate={requestConfig.createComment({
                id,
            })}
            deleteComment={deleteComment}
            onParamsChange={onParamsChange}
            loadData={loadData}
            refetch={refetch}
            className={classes.root}
        />
    )
}

export default PreBookingComment
